import { service } from '@/common/request/request.js'

// 查询可购买的余额宝列表
export function getYEBList(data = {}) {
  return service({
    url: '/applyBonus/selectBonusBalanceProfitList',
    method: 'post',
    data
  })
}

// 查询已购买的余额宝列表
export function getMyYEBList(data = {}) {
  return service({
    url: '/applyBonus/queryUserBuyBalanceProfitList',
    method: 'post',
    data
  })
}

// 购买余额宝
export function buyYEB(data = {}) {
  return service({
    url: '/applyBonus/buyBalanceProfit',
    method: 'post',
    data
  })
}

// 赎回余额宝
export function redeemYEB(data = {}) {
  return service({
    url: '/applyBonus/ransomBalanceProfit',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/common/api/YuEBao.js